import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'Authentication'
}

const initializeAuth = new Action('initializeAuth')

const updateField = new Action('updateField', {
  success: (key, value) => ({ key, value }),
})

const setAuthUsername = new Action('setAuthUsername', {
  success: (username) => ({ username }),
})

const resetLogIn = new Action('resetLogIn', {
  success: () => ({}),
})

const logInUser = new Action('logInUser', {
  init: (username, isEmail, nextUrl, callback) => ({
    username,
    isEmail,
    nextUrl,
    callback,
  }),
  success: (username, userAlias) => ({ username, userAlias }),
  failure: (code, message, name) => ({ code, message, name }),
})

const confirmLogInUser = new Action('confirmLogInUser', {
  init: (code, userAlias, callback) => ({ code, userAlias, callback }),
  success: () => ({}),
  failure: (code, message, name) => ({ code, message, name }),
})

const signOutUser = new Action('signOutUser', {
  init: (callback) => ({ callback }),
  success: (data) => data,
  failure: (data) => data,
})

const checkIsAuthenticated = new Action('checkIsAuthenticated', {
  success: (isAuthenticated) => ({ isAuthenticated }),
})

export default {
  initializeAuth,
  updateField,
  setAuthUsername,
  resetLogIn,
  logInUser,
  confirmLogInUser,
  signOutUser,
  checkIsAuthenticated,
}
